import CreateInvestmentError from './CreateInvestmentError';
class BrickNumberExceedsMaximumBricks extends CreateInvestmentError {
    constructor(options) {
        super('The number of bricks purchased is bigger than maximum bricks', options);
    }
}
export default BrickNumberExceedsMaximumBricks;
